import { render, staticRenderFns } from "./MobileMentor.vue?vue&type=template&id=31be6a3c"
import script from "./MobileMentor.vue?vue&type=script&lang=js"
export * from "./MobileMentor.vue?vue&type=script&lang=js"
import style0 from "./MobileMentor.vue?vue&type=style&index=0&id=31be6a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports